import {
    Event4Program,
    HorseRacingOdds,
    LightHrEvent
} from '@pturf-betin/betin-models-lib'
import dayjs from 'dayjs'
import {
    CollectionReference,
    DocumentData,
    Firestore,
    Query,
    collection,
    doc,
    getDoc,
    getDocs,
    getFirestore,
    query,
    where
} from 'firebase/firestore'
import { dataFB } from './firebase'

export enum EFSCollection {
    BetinFullProgram = 'betinFullProgram',
    betinFullProgramEvents = 'betinFullProgramEvents',
    BetinOdds = 'betinOdds',
    BetinLightHrProgram = 'betinLightHrProgram',
    BetinConfig = 'betinConfig'
}

// Firestore instances
const dataFS = getFirestore(dataFB)

// Utils
const getCollection = <T extends DocumentData>(
    collectionName: EFSCollection | string,
    database: Firestore = dataFS
) => collection(database, collectionName) as CollectionReference<T>

export const getFirstOrNull = async <T>(q: Query | null): Promise<T | null> => {
    if (!q) return null

    return getDocs(q)
        .then(async (querySnapshot) => {
            const result: T[] = []
            if (querySnapshot.empty) {
                return null
            }
            querySnapshot.forEach((doc) => result.push(doc.data() as T))
            return result[0]
        })
        .catch(async (e: Error) => {
            console.error(e)
            return null
        })
}

// export const getAllOrEmpty = async <T>(q: Query): Promise<T[]> => {
//     const querySnapshot = await getDocs(q)
//     const result: Array<T> = []
//     if (querySnapshot.empty) return result
//     querySnapshot.forEach((doc) => result.push(doc.data() as T))
//     return result
// }

export const getUpcomingHorseRacingProgramEvents = async (
    date: string = dayjs().format('YYYY-MM-DD').toString()
): Promise<LightHrEvent[]> => {
    const hrProgramRef = getCollection(
        `${EFSCollection.BetinFullProgram}/${date}/${EFSCollection.BetinLightHrProgram}`
    )
    const hrQuery = query(hrProgramRef)
    const hrProgram = (await getFirstOrNull(hrQuery)) as {
        events: LightHrEvent[]
    } | null
    if (!hrProgram || !hrProgram?.events?.length) return []
    return hrProgram.events.sort(
        (a, b) => new Date(a.stDt).getTime() - new Date(b.stDt).getTime()
    )
}

export const getBetinRaceById = async (
    raceId: string,
    raceDate?: string
): Promise<Event4Program | null> => {
    const date = raceDate ? dayjs(raceDate) : dayjs()
    const ref = getCollection(
        `${EFSCollection.BetinFullProgram}/${date.format('YYYY-MM-DD')}/${EFSCollection.betinFullProgramEvents}`
    )

    const q = query(ref, where('id', '==', raceId))
    return getFirstOrNull<Event4Program>(q)
}

export const getBetinOddsByRaceId = async (
    raceId: string
): Promise<HorseRacingOdds | null> => {
    const ref = getCollection(EFSCollection.BetinOdds)
    const q = query(ref, where('raceId', '==', +raceId))
    return getFirstOrNull<HorseRacingOdds>(q)
}

export const getPmuBonus = async (): Promise<number | undefined> => {
    const ref = doc(dataFS, EFSCollection.BetinConfig, 'betinBetslip')
    const docSnap = await getDoc(ref)
    if (!docSnap.exists()) return undefined
    return docSnap.data()?.pmuBonus as number | undefined
}
